import { render, staticRenderFns } from "./Service-1.vue?vue&type=template&id=c5400e02&scoped=true&"
import script from "./Service-1.vue?vue&type=script&lang=js&"
export * from "./Service-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5400e02",
  null
  
)

export default component.exports